import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ConflictChip = styled(Chip)`
  font-size: 11px;
  height: 20px;
  font-weight: 600;
`;
